import {
  GET_CATEGORY_DATA_INIT,
  GET_CATEGORY_DATA_SUCCESS,
  GET_CATEGORY_DATA_FAILURE,
  GET_FILTERED_DATA_INIT,
  GET_FILTERED_SUCCESS,
  GET_FILTERED_FAILURE,
  UPDATE_LOADING,
} from '../actions/types';
import initialState from './initialState';

/**
 * Reducer for Map information
 * -crash categories, data filtered
 */
export default function (state = initialState.map, action) {
  switch (action.type) {
    // Cases to update the loading state
    case UPDATE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

      // Cases to fetch the categories
    case GET_CATEGORY_DATA_INIT:
      return {
        ...state,
        errorCategories: null,
      };
    case GET_CATEGORY_DATA_SUCCESS:
      return {
        ...state,
        categories: { ...state.categories, ...action.payload },
        errorCategories: null,
      };
    case GET_CATEGORY_DATA_FAILURE:
      return {
        ...state,
        errorCategories: action.payload,
      };

      // Cases to fetch the data filtered
    case GET_FILTERED_DATA_INIT:
      return {
        ...state,
        errorFiltered: null,
        loading: true,
      };
    case GET_FILTERED_SUCCESS:
      return {
        ...state,
        incidentsFiltered: action.payload[0],
        totalNumber: action.payload[1],
        selectedFilters: action.payload[2],
        errorFiltered: null,
      };
    case GET_FILTERED_FAILURE:
      return {
        ...state,
        errorFiltered: action.payload[0],
        incidentsFiltered: action.payload[1],
        totalNumber: action.payload[2],
        selectedFilters: action.payload[3],
        loading: false,
      };

    default:
      return state;
  }
}
